// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,

  base_url: 'https://staging-be.travelchapel.com/admin',
  image_url: 'https://staging-be.travelchapel.com/',
  file_url : ' https://staging-be.travelchapel.com/uploads/csv/',
  socketUrl: 'https://staging-be.travelchapel.com/',

  // base_url: 'https://08ce-202-131-117-90.ngrok-free.app/admin',
  // image_url: 'https://08ce-202-131-117-90.ngrok-free.app/',
  // file_url : ' https://08ce-202-131-117-90.ngrok-free.app/uploads/csv/',
  // socketUrl: 'https://08ce-202-131-117-90.ngrok-free.app/',

  // base_url: 'https://node-travel-chapel-backend.agiletechnologies.in/admin',
  // image_url: 'https://node-travel-chapel-backend.agiletechnologies.in/',
  // socketUrl: 'https://node-travel-chapel-backend.agiletechnologies.in/',
  // file_url : 'https://node-travel-chapel-backend.agiletechnologies.in/uploads/csv/',


    // base_url: 'http://202.131.117.92:7054/admin',
    // image_url: 'http://202.131.117.92:7054/',
    // socketUrl: 'http://202.131.117.92:7054/',
    // file_url : 'http://202.131.117.92:7054/uploads/csv/',
    chatNamespace: 'v8/xcode',
    imagePath: '../assets/img/pdfIcon.png',    
};


